import DocumentNameFilter from './DocumentNameFilter';

export default DocumentNameFilter;
